export default __webpack_public_path__ + "static/media/retiment4.9f4bcd66.png";